import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import * as designers from '../../../constants/designerpages';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class SingleDesigner extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const designer = designers.ALL[this.props.route.designer_code];
		if(!designer) {
			this.context.router.push('/designers-links');
		}

		this.state = {
			designer: designer,
		}
	}

	componentWillMount() {
		
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.state.designer.titleName) {
			document.title = this.state.designer.titleName + ' Engagement & Wedding Rings - Diamonds Direct';
    	document.getElementsByTagName("META")[7].content = "Shop Beautiful " + this.state.designer.titleName + " Engagement or Wedding Rings Online or at one of our Nationwide Diamonds Direct Locations!";
		} else {
			document.title = 'Designer Engagement & Wedding Rings - Diamonds Direct';
    	document.getElementsByTagName("META")[7].content = "Shop Beautiful Engagement or Wedding Rings Online or at one of our Nationwide Diamonds Direct Locations!";
		}
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

	render() {
		return <div className='SingleDesigner'>
			<div className={'designerBanner desktopOnly'} style={{backgroundImage: 'url("https://ddw2.diamondsdirect.com/img/designers/singledesigner/desktop/' + this.props.route.designer_code + '_banner.jpg")'}}>
				<div className='bannerOverlay'>
					<div className='bannerLogo'>
						<img 
							src={this.state.designer.logoImg ? 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.state.designer.logoImg : 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.props.route.designer_code + '.svg'}
							style={this.state.designer.logoStyle ? this.state.designer.logoStyle : {}} />
					</div>
					<div className={this.state.designer.links ? 'bannerDescription multipleLinks' : 'bannerDescription'}>
						{this.state.designer.description.map((desc, i) => {
							return <div className='descriptionP' key={i}>{desc}</div>
						})}
					</div>
					{this.state.designer.links ?
						<div className='bannerButtons multipleButtons'>
							{this.state.designer.links.map((linkData, i) => {
								return <div className={'onlineButton bannerButton shortButton'} key={i}>
									<div className='buttonText' onClick={() => this.userNav(linkData.url)}>
										Shop {linkData.name}&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
									</div>
								</div>
							})}
							<div className={'instoreButton bannerButton shortButton'}>
								<div className='buttonText' onClick={() => this.internalNav('locations')}>
									Shop In Store&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
								</div>
							</div>
						</div> :
						<div className='bannerButtons'>
							{this.state.designer.shopLink ?
								<div className={'onlineButton bannerButton'}>
									<div className='buttonText' onClick={() => this.internalNav(this.state.designer.shopLink)}>
										Shop {this.state.designer.displayName} Online&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
									</div>
								</div> :
								null
							}
							<div className={'instoreButton bannerButton'}>
								<div className='buttonText' onClick={() => this.internalNav('locations')}>
									Shop {this.state.designer.displayName} In Store&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
			<div className={'designerMobileWrapper mobileOnly'}>
				<div className={'designerMobileBanner'}>
					<img src={'https://ddw2.diamondsdirect.com/img/designers/singledesigner/mobile/' + this.props.route.designer_code + '_mobile.jpg'} />
				</div>
				<div className='mobileLogo'>
					<img src={this.state.designer.logoImg ? 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.state.designer.logoImg : 'https://ddw2.diamondsdirect.com/img/designers/logos/' + this.props.route.designer_code + '.svg'} />
				</div>
				<div className='mobileDescription'>
					{this.state.designer.description.map((desc, i) => {
						return <div className='descriptionP' key={i}>{desc}</div>
					})}
				</div>
				<div className='mobileButtons'>
					{this.state.designer.links ?
						<div>
							{this.state.designer.links.map((linkData, i) => {
								return <div className={'mobileOnlineButton mobileBannerButton'} key={i}>
									<div className='buttonText' onClick={() => this.userNav(linkData.url)}>
										Shop {linkData.name}&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
									</div>
								</div>
							})}
						</div> :
						<div>
							{this.state.designer.shopLink ?
								<div className={'mobileOnlineButton mobileBannerButton'}>
									<div className='buttonText' onClick={() => this.userNav(this.state.designer.shopLink)}>
										Shop {this.state.designer.displayName} Online&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
									</div>
								</div> :
								null
							}
						</div>
					}
					<div className={'mobileInstoreButton mobileBannerButton'}>
						<div className='buttonText' onClick={() => this.internalNav('locations')}>
							Shop {this.state.designer.displayName} In Store&nbsp;&nbsp;<span className='buttonArrow'><i className={"fas fa-caret-right"}></i></span>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default SingleDesigner;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const SingleDesignerContainer = connect(
  mapStateToProps,
  allActionCreators
)(SingleDesigner);


// WEBPACK FOOTER //
// ./src/components/views/designers/SingleDesigner.jsx